// src/pages/Services.js
import CmsPage from "../components/pages/CmsPage";

export default function Services() {
  return (
    <CmsPage
      slug="services"
      fallbackTitle="Services"
      fallbackContent=""
    />
  );
}
